/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { GetVerificationInfoErrorResponse, GetVerificationInfoResponse } from './api.schemas';

import { api } from '../util/http';

export const getEncountersIdentityVerificationInfo = (
  encounterId: number,
  signal?: AbortSignal,
) => {
  return api<GetVerificationInfoResponse>({
    url: `/api/encounters/${encounterId}/identity-verification/info`,
    method: 'GET',
    signal,
  });
};

export const getGetEncountersIdentityVerificationInfoQueryKey = (encounterId?: number) => {
  return [`/api/encounters/${encounterId}/identity-verification/info`] as const;
};

export const getGetEncountersIdentityVerificationInfoQueryOptions = <
  TData = Awaited<ReturnType<typeof getEncountersIdentityVerificationInfo>>,
  TError = GetVerificationInfoErrorResponse,
>(
  encounterId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEncountersIdentityVerificationInfo>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetEncountersIdentityVerificationInfoQueryKey(encounterId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getEncountersIdentityVerificationInfo>>
  > = ({ signal }) => getEncountersIdentityVerificationInfo(encounterId, signal);

  return { queryKey, queryFn, enabled: !!encounterId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEncountersIdentityVerificationInfo>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetEncountersIdentityVerificationInfoQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEncountersIdentityVerificationInfo>>
>;
export type GetEncountersIdentityVerificationInfoQueryError = GetVerificationInfoErrorResponse;

export function useGetEncountersIdentityVerificationInfo<
  TData = Awaited<ReturnType<typeof getEncountersIdentityVerificationInfo>>,
  TError = GetVerificationInfoErrorResponse,
>(
  encounterId: number,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEncountersIdentityVerificationInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEncountersIdentityVerificationInfo>>,
          TError,
          Awaited<ReturnType<typeof getEncountersIdentityVerificationInfo>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEncountersIdentityVerificationInfo<
  TData = Awaited<ReturnType<typeof getEncountersIdentityVerificationInfo>>,
  TError = GetVerificationInfoErrorResponse,
>(
  encounterId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEncountersIdentityVerificationInfo>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEncountersIdentityVerificationInfo>>,
          TError,
          Awaited<ReturnType<typeof getEncountersIdentityVerificationInfo>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEncountersIdentityVerificationInfo<
  TData = Awaited<ReturnType<typeof getEncountersIdentityVerificationInfo>>,
  TError = GetVerificationInfoErrorResponse,
>(
  encounterId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEncountersIdentityVerificationInfo>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetEncountersIdentityVerificationInfo<
  TData = Awaited<ReturnType<typeof getEncountersIdentityVerificationInfo>>,
  TError = GetVerificationInfoErrorResponse,
>(
  encounterId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getEncountersIdentityVerificationInfo>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetEncountersIdentityVerificationInfoQueryOptions(encounterId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
